import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30be2c31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-box" }
const _hoisted_2 = { style: {"margin-bottom":"16px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-content" }, "1、下载批量减保模板，批量填写信息", -1))
const _hoisted_4 = { style: {"margin-bottom":"16px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-content" }, "2、上传填写好的信息表", -1))
const _hoisted_6 = { style: {"margin-bottom":"16px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-content" }, "3、文件选择无误后提交减保", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { UploadOutlined } from "@ant-design/icons-vue";
import { message, UploadChangeParam } from "ant-design-vue";
import { DownloadOutlined } from "@ant-design/icons-vue";
import {
  downLoadTemplate,
  importExcelData,
  getAttachmentList,
  downloadFileByPos,
} from "@/api/pos";
import { ACCESS_TOKEN } from "@/config/config";
import api from "@/api/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'PosBatchReduce',
  setup(__props) {

const dataSource = ref<Array<any>>([]);
const loading = ref<boolean>(false);
const route = useRoute();
const checkPosDetailInfo = ref(null);
const currentPage = ref(1);
const pageSizeConfig = ref(10);
const totalData = ref(0);
const attachmentId = ref(0);
const fileList = ref([]);
const uploadUrl = api.uploadForPosBatch;
const uploadRequestHeaders = ref({
  "HrPortal-Access-Token": `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
  Accept: "application/json",
});
const columns = ref<Array<any>>([
  {
    title: "文件名称",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "操作人",
    dataIndex: "petName",
    key: "petName",
  },
  {
    title: "操作时间",
    dataIndex: "createdAtTime",
    key: "createdAtTime",
  },
  {
    title: "状态",
    dataIndex: "operationStateZh",
    key: "operationStateZh",
  },
]);
onMounted(() => {
  getTableData();
});
const getTableData = async (paramater: any = {}) => {
  paramater.typeList = ["REDUCE"];
  let res: any = await getAttachmentList(paramater);
  if (res.code == 200) {
    dataSource.value = res.data.dataList;
    totalData.value = res.data.total;
    checkFileState(res.data.dataList);
  }
};
const handleUpload = (info: UploadChangeParam) => {
  if (info.file.status !== "uploading") {
    console.log(info.file, info.fileList);
  }
  if (info.file.status === "done") {
    message.success(`${info.file.name} file uploaded successfully`);
    if (
      info.fileList[0].response.code == 200 &&
      info.fileList[0].response.data.id
    ) {
      attachmentId.value = info.fileList[0].response.data.id;
      console.log(
        "%c [ info.fileList[0].response.data.id ]-103",
        "font-size:13px; background:pink; color:#bf2c9f;",
        info.fileList[0].response.data.id
      );
    }
  } else if (info.file.status === "error") {
    message.error(`${info.file.name} file upload failed.`);
  }
};
const handleDownloadTemplate = async () => {
  let res: any = await downLoadTemplate({ type: "REDUCE" });
  let a = document.createElement("a");
  a.href = res.data;
  a.click();
};
const onChangePage = (pageNum: number, pageSize: number) => {
  let data = {
    pageNum: pageNum,
    pageSize: pageSize,
  };
  pageSizeConfig.value = pageSize;
  currentPage.value = pageNum;
  getTableData(data);
};

const importFile = async () => {
  if (attachmentId.value == 0) {
    message.error("请上传文件再提交");
  } else {
    let res: any = await importExcelData({ fileId: attachmentId.value });
    if (res.code == 200) {
      message.success("导入成功");
      fileList.value = [];
      attachmentId.value = 0;
      getTableData();
    } else {
      message.error(res.msg);
    }
  }
};
const getDownloadUrl = async (record: any) => {
  let paramater = {
    id: record.id,
    duration: 600,
  };
  let res: any = await downloadFileByPos(paramater);
  if (res.code == 200) {
    let a = document.createElement("a");
    a.href = res.data;
    a.click();
    message.success("下载成功");
  } else {
    message.error(res.msg);
  }
};
const checkFileState = (list: Array<any>) => {
  list.forEach((e) => {
    if (e.operationState == "IMPORTING") {
      setTimeout(() => {
        getTableData();
      }, 3000);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    style: {"max-width":"1440px","margin":"0 auto","margin-top":"32px","text-align":"left"},
    title: "批量减人"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_row, { class: "row-c" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_a_button, {
                style: {"margin-left":"16px"},
                type: "primary",
                onClick: handleDownloadTemplate
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DownloadOutlined)),
                  _createTextVNode("下载批量减人模板")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_row, { class: "row-c" }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_a_upload, {
                "file-list": fileList.value,
                "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
                name: "file",
                headers: uploadRequestHeaders.value,
                action: _unref(uploadUrl),
                onChange: handleUpload,
                maxCount: 1,
                data: { type: 'REDUCE' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    style: {"margin-left":"16px"},
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadOutlined)),
                      _createTextVNode(" 选择文件")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "headers", "action"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_row, { class: "row-c" }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_a_button, {
                style: {"margin-left":"16px"},
                type: "primary",
                onClick: importFile
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交减人")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_a_table, {
        dataSource: dataSource.value,
        columns: columns.value,
        pagination: {
        current: currentPage.value,
        onChange: onChangePage,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total: totalData.value,
        pageSize: pageSizeConfig.value,
      },
        loading: loading.value
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.key === 'name')
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                (
              record.operationState == 'IMPORTED_ERROR' ||
              record.operationState == 'VERIFY_ERROR'
            )
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      style: {"color":"red"},
                      onClick: ($event: any) => (getDownloadUrl(record))
                    }, _toDisplayString(record.name), 9, _hoisted_9))
                  : _createCommentVNode("", true),
                (
              record.operationState != 'IMPORTED_ERROR' &&
              record.operationState != 'VERIFY_ERROR'
            )
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      style: {"color":"#42b983"},
                      onClick: ($event: any) => (getDownloadUrl(record))
                    }, _toDisplayString(record.name), 9, _hoisted_10))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (column.key === 'operationStateZh')
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                (record.operationState == 'VERIFY_ERROR')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(record.operationStateZh) + "（请下载文件查看错误）", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(record.operationStateZh), 1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination", "loading"])
    ]),
    _: 1
  }))
}
}

})